module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'content\' id=\'dashboard-content\' style=\'position: relative; text-align: center; width: 100%; margin: 0 auto;\'>\n    <div class="navbar dashboard-navbar" id="global-dashboard-header">\n    </div>\n    <div id=\'total-displayers\'></div>\n    <div id="widgets-wrapper">\n        <div class=\'basic-widget grid-half\'>\n            <div class=\'content-map\'>\n                <div id=\'dashboard-placeholder\'></div>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}